import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useAppSelector } from '../../hooks/useAppSelector';
import { configSelector } from '../../redux/ConfigState/ConfigState.selectors';
import { updatePaymentState } from '../../redux/PaymentState/PaymentState.actions';
import InitializeBraintree from '../InitializeBraintree';
import UpiOption from '../UpiOption/UpiOption';
import { getCheckoutSdkAuthParams, initializeApp, initializeSDK } from './utils';
import { Processors } from '../../constants/AppConstants';
import InitializeAdyen from '../InitializeAdyen';
import InitializeRecurly from '../InitializeRecurly';
var App = function App(props) {
  var config = useAppSelector(configSelector);
  var dispatch = useDispatch();
  var cartPriceSummary = props.cartPriceSummary;
  var authorization = config.authorization,
    rioNamespace = config.rioNamespace,
    upi = config.upi,
    paymentProcessors = config.paymentProcessors,
    isRecurly = config.isRecurly;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    authorized = _useState2[0],
    setAuthorized = _useState2[1];
  useEffect(function () {
    initializeApp(authorization === null || authorization === void 0 ? void 0 : authorization.cheggBaseUrl, dispatch);
    var isAuthorized = authorization && initializeSDK(getCheckoutSdkAuthParams(authorization), rioNamespace);
    setAuthorized(isAuthorized);
    dispatch(updatePaymentState({
      cartPriceSummary: cartPriceSummary
    }));
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, getPaymentOption());

  /*
    This function should determine which experience i.e. vendor should be used.
   */
  function getPaymentOption() {
    if (!authorized) return null;
    if (isRecurly) return /*#__PURE__*/React.createElement(InitializeRecurly, props);
    if (upi) return /*#__PURE__*/React.createElement(UpiOption, null);
    if (paymentProcessors !== null && paymentProcessors !== void 0 && paymentProcessors.includes(Processors.ADYEN)) return /*#__PURE__*/React.createElement(InitializeAdyen, props);
    return /*#__PURE__*/React.createElement(InitializeBraintree, props);
  }
};
export default /*#__PURE__*/React.memo(App);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/internals/App/index.js
// module id = 4534
// module chunks = 11